//-----------------------
// calc skill adj totals
//-----------------------
export default function calcSkillAdjTotals({ category_adjs, skill, type }) {
  console.log('---------------------------------')
  console.log('IN calcSkillAdjTotals')
  console.log('1. type = ' + type)
  // console.log('2. category_adjs = ', category_adjs)
  console.log('3. skill = ', skill)
  console.log('4. skill name = ', skill.name)
  console.log('5. skill display_name = ', skill.display_name)
  //----------
  // declares
  //----------
  let return_totals = {
    adjs_tot: 0,
    adjs_tot_character_skill: 0,
    adjs_tot_characteristic_skill: 0,
    adjs_tot_integrated_rune_skill: 0,
  }
  // console.log('================================================')
  // console.log('========== A. CHARACTER (SKILLS ADJS) ==========')
  // console.log('================================================')
  //---------------------------------
  // A. get character adjs for skill
  //    (exclude optional/applied=false entries)
  //---------------------------------
  const adjs_skill = category_adjs.filter(
    (adj) =>
      (adj.name === type || adj.name === skill.display_name || adj.name === skill.name) &&
      adj.source === 'character' &&
      adj.applied !== false,
  )
  console.log('7. adjs_skill = ', adjs_skill)
  //---------------------------------------------
  // A. where got adjs - calc adj totals (skill)
  //---------------------------------------------
  if (adjs_skill && adjs_skill.length > 0) {
    return_totals.adjs_tot_character_skill = adjs_skill.reduce(
      (sum, adj) => sum + (adj.adj_value || 0),
      0,
    )
  }
  console.log('>>>>> adjs_tot_character_skill = ', return_totals.adjs_tot_character_skill)
  // console.log('=====================================================')
  // console.log('========== B. CHARACTERISTIC (SKILLS ADJS) ==========')
  // console.log('=====================================================')
  // //--------------------------------------
  // B. get characteristic adjs for skill
  //--------------------------------------
  //-------------------------------------------
  // B. calc adj totals (characteristic skill)
  //-------------------------------------------
  const adjs_characteristic_skill = skill.parent_name
    ? []
    : category_adjs.filter(
        (adj) => adj.name === type && adj.source === 'characteristic' && adj.applied !== false,
      )
  //------------------------------------------------------
  // B. where got adjs - calc adj totals (characteristic)
  //------------------------------------------------------
  if (adjs_characteristic_skill && adjs_characteristic_skill.length > 0) {
    return_totals.adjs_tot_characteristic_skill = adjs_characteristic_skill.reduce(
      (sum, adj) => sum + (adj.adj_value || 0),
      0,
    )
  }
  console.log('>>>>> adjs_tot_characteristic_skill = ', return_totals.adjs_tot_characteristic_skill)
  // console.log('======================================================')
  // console.log('========== C. INTEGRATED RUNE (SKILLS ADJS) ==========')
  // console.log('======================================================')
  //---------------------------------------
  // C. get integrated rune adjs for skill
  //---------------------------------------
  //------------------------------------------------------------------------------------------------------------
  // C1. where runecasting - need to include both 'Runecasting' & specific skill name adjs e.g. 'Darkness Rune'
  //------------------------------------------------------------------------------------------------------------
  const adjs_rune = category_adjs.filter(
    (adj) =>
      (adj.name === type || adj.name === skill.display_name || adj.name === skill.name) &&
      adj.source === 'integrated_rune' &&
      adj.applied !== false,
  )
  //-------------------------------------------------------
  // C. where got adjs - calc adj totals (integrated rune)
  //-------------------------------------------------------
  return_totals.adjs_tot_integrated_rune_skill = adjs_rune.reduce(
    (sum, adj) => sum + (adj.adj_value || 0),
    0,
  )
  console.log(
    '>>>>> adjs_tot_integrated_rune_skill = ',
    return_totals.adjs_tot_integrated_rune_skill,
  )
  // console.log('============================================')
  // console.log('========== D. CALC OVERALL TOTALS ==========')
  // console.log('============================================')
  return_totals.adjs_tot =
    return_totals.adjs_tot_character_skill +
    return_totals.adjs_tot_characteristic_skill +
    return_totals.adjs_tot_integrated_rune_skill
  console.log('>>>>> adjs_tot = ', return_totals.adjs_tot)
  console.log('-------------------------------------')
  console.log('RETURN TOTALS = ', return_totals)
  //---------------
  return return_totals
}
